import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-offender-list',
  templateUrl: './offender-list.component.html',
  styleUrls: ['./offender-list.component.scss']
})
export class OffenderListComponent implements OnChanges {

  @Input() items: any[] = [];
  @Input() isVisible: boolean = false;

  @Output() flyTo = new EventEmitter<{ lng: number; lat: number }>();
  @Output() toggleLayer = new EventEmitter<void>();

  search = '';
  filterCircuit = '';
  currentPage = 1;
  readonly pageSize = 25;

  filtered: any[] = [];
  circuits: string[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items']) {
      this.buildCircuits();
      this.applyFilters();
    }
  }

  buildCircuits(): void {
    const set = new Set<string>();
    (this.items || []).forEach(o => { if (o.circuit_code) set.add(o.circuit_code); });
    this.circuits = Array.from(set).sort();
  }

  applyFilters(): void {
    const s = this.search.toLowerCase().trim();
    this.filtered = (this.items || []).filter(o => {
      if (this.filterCircuit && o.circuit_code !== this.filterCircuit) return false;
      if (s) {
        const hay = [o.full_name, o.doc_num, o.address1, o.address2, o.city, o.zip, o.circuit_code]
          .join(' ').toLowerCase();
        if (!hay.includes(s)) return false;
      }
      return true;
    });
    this.currentPage = 1;
  }

  get pagedItems(): any[] {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.filtered.slice(start, start + this.pageSize);
  }

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.filtered.length / this.pageSize));
  }

  prevPage(): void {
    if (this.currentPage > 1) this.currentPage--;
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) this.currentPage++;
  }

  onView(o: any): void {
    if (o.latitude != null && o.longitude != null) {
      this.flyTo.emit({ lng: o.longitude, lat: o.latitude });
    }
  }

  titleCase(s: string): string {
    return (s || '').toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
  }

  /** Left border accent: all offenders use the same orange on the map and in the list. */
  addrTypeColor(_type: string): string {
    return '#f97316';
  }
}
